import { useNavigate, useParams } from "react-router-dom";
import searchFill from "@iconify/icons-eva/search-fill";

import {
  Box,
  Stack,
  InputAdornment,
  Chip,
  OutlinedInput,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import { useEffect, useState } from "react";
import { s3baseUrl } from "src/config/config";
import { htmlDecode } from "src/utils/convertHtml";
import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import RecordNotFound from "src/components/RecordNotFound";

import { AllExerciseListingApi } from "src/DAL/exercise/exercise";
import InfiniteScroll from "react-infinite-scroll-component";
import CustomDrawer from "src/components/DrawerForm/CustomDrawer";
import ExerciseFilter from "./ExerciseFilterNew";
import { Icon } from "@iconify/react";
import roundFilterList from "@iconify/icons-ic/round-filter-list";
import { ExerciseTagesApi } from "src/DAL/exerciseType/exerciseType";
import Label from "src/components/Label";
import { useContentSetting } from "src/Hooks/ContentSettingState";
const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));
const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(["box-shadow", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  "&.Mui-focused": { width: 280, boxShadow: theme.customShadows.z8 },
  "& fieldset": {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
    top: 0,
  },
  "& legend": {
    display: "none",
  },
  "@media (max-width: 600px)": {
    width: 240,
    "&.Mui-focused": {
      width: 240,
    },
  },
}));
const tabs = {
  all: "",
  asc: "asc",
  close: "desc",
  trash: "trash",
};
export default function ExercisListing() {
  const id = useParams();
  const classes = useStyles();
  const navigate = useNavigate();
  const [exercise, setExercise] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filterName, setFilterName] = useState("");
  const { userInfo } = useContentSetting();

  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [filterCount, setFilterCount] = useState(0);
  const [exercisetag, setExerciseTag] = useState([]);
  const [difficulty, setDifficulty] = useState([]);
  const [main_muscle, setMainMuscle] = useState([]);
  const [conditionMetOnce, setConditionMetOnce] = useState(false);

  const [filterDrawerState, setFilterDrawerState] = useState(false);
  const EMPTY_FILTER = {
    exercises: [],
    mainMuscle: [],
    difficulty: [],
    search_text: "",
    status: "",
    exercise_type: null,
  };
  const [selectedTab, setSelectedTab] = useState(tabs.asc);
  const [filterState, setFilterState] = useState(EMPTY_FILTER);
  const [filterStateUpdated, setFilterStateUpdated] = useState(EMPTY_FILTER);
  const searchFunction = () => {
    setPage(0);
    filterState.search_text = filterName;
    getExerciseList(filterState);
    localStorage.setItem("ExercisesListSearch", JSON.stringify(filterState));
    handleCloseFilterDrawer();
    setIsLoading(true);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };
  const handleClearFilter = () => {
    let clear_data = { ...EMPTY_FILTER };
    setPage(0);
    setFilterName("");
    setFilterState(clear_data);

    getExerciseList(clear_data);
    handleCloseFilterDrawer();
    setIsLoading(true);
    localStorage.removeItem("ExercisesListSearch");
  };
  const handleOpenFilterDrawer = () => {
    setFilterDrawerState(true);
    setFilterState(filterStateUpdated);
  };
  const handleCloseFilterDrawer = () => {
    setFilterDrawerState(false);
  };
  const fetchMoreData = () => {
    setPage((prev) => prev + 1);
  };
  const getExerciseList = async (filterData) => {
    let postdata = {
      difficulty: filterData.difficulty,
      exercise: filterData.exercises,
      main_muscle: filterData.mainMuscle,
      exercise_type: filterData?.exercise_type
        ? filterData?.exercise_type._id
        : "",
    };

    let result = await AllExerciseListingApi(
      page,
      rowsPerPage,
      filterName,
      postdata,
      filterData?.status,
      selectedTab,
    );
    if (result.code == 200) {
      let filtersCount =
        filterData?.difficulty.length +
        filterData?.exercises.length +
        filterData?.mainMuscle.length;
      setFilterCount(
        filterData?.difficulty.length +
          filterData?.exercises.length +
          filterData?.mainMuscle.length,
      );
      if (filterData?.status) {
        setFilterCount((values) => values + 1);
        filtersCount = filtersCount + 1;
      }
      if (filterData?.exercise_type) {
        setFilterCount((values) => values + 1);
        filtersCount = filtersCount + 1;
      }

      let chipData = filterData;
      if (chipData.search_text) {
        delete chipData.search_text;
      }

      setFilterStateUpdated(chipData);
      setIsLoading(false);
      const newData = result?.exercises;

      setTotalCount(result.total_exercises);
      if (!filtersCount && !filterCount && !filterName) {
        setConditionMetOnce(false);
      }
      if (
        (filtersCount == 1 || filterCount == 1 || filterName.length > 0) &&
        !conditionMetOnce
      ) {
        setExercise(result?.exercises);
        setPage(0);

        setConditionMetOnce(true);
        return;
      } else {
        let mergedData;
        if (page === 0) {
          mergedData = newData;
        } else {
          mergedData = [...exercise, ...newData];
        }
        let sortedMergedData = [...mergedData];
        let sortedMergedDataagain = [...mergedData];

        if (selectedTab === "asc") {
          sortedMergedData.sort((a, b) => {
            return a.title.localeCompare(b.title);
          });
        } else if (selectedTab === "desc") {
          sortedMergedData.sort((a, b) => {
            return b.title.localeCompare(a.title);
          });
        }
        if (filterName) {
          const word = filterName.toLowerCase();
          sortedMergedData.sort((a, b) => {
            const startsWithA = a.title.toLowerCase().startsWith(word);
            const startsWithB = b.title.toLowerCase().startsWith(word);

            if (startsWithA && !startsWithB) {
              return -1;
            }
            if (!startsWithA && startsWithB) {
              return 1;
            }
            return a.title.localeCompare(b.title);
          });
        }
        if (filterName !== "") {
          setExercise(sortedMergedDataagain);
        } else {
          setExercise(sortedMergedData);
        }
      }
    }
  };
  const getExerciseTagesListing = async () => {
    setIsLoading(true);

    try {
      setIsLoading(true);

      const result = await ExerciseTagesApi();
      if (result.code === 200) {
        setExerciseTag(result?.tags?.exercise);
        setDifficulty(result?.tags?.difficulty);
        setMainMuscle(result?.tags?.main_muscle);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
    } finally {
    }
  };
  useEffect(() => {
    getExerciseTagesListing();
  }, []);
  useEffect(() => {
    let filter_data = EMPTY_FILTER;
    let find_filter = localStorage.getItem("ExercisesListSearch");
    if (find_filter) {
      filter_data = JSON.parse(find_filter);
      if (filter_data.search_text) {
        setFilterName(filter_data.search_text);
      }
    }
    setFilterState(filter_data);
    setFilterStateUpdated(filter_data);
    getExerciseList(filter_data);
  }, [page, rowsPerPage, selectedTab]);
  useEffect(() => {
    let filter_data = EMPTY_FILTER;
    let find_filter = localStorage.getItem("ExercisesListSearch");
    if (find_filter) {
      filter_data = JSON.parse(find_filter);
    }
    setFilterState(filter_data);
    setFilterStateUpdated(filter_data);
    const timer = setTimeout(() => {
      setPage(0);
      getExerciseList(filter_data);
    }, 500);

    return () => clearTimeout(timer);
  }, [filterName]);
  useEffect(() => {
    setIsLoading(true);
    setPage(0);
    setExercise([]);
  }, [selectedTab]);
  if (isLoading === true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <>
      <div className="container-fluid">
        <CustomDrawer
          isOpenDrawer={filterDrawerState}
          onOpenDrawer={handleOpenFilterDrawer}
          onCloseDrawer={handleCloseFilterDrawer}
          pageTitle="Filters"
          componentToPassDown={
            <ExerciseFilter
              filterData={filterState}
              setFilterData={setFilterState}
              searchSubmitFilter={searchFunction}
              handleClearFilter={handleClearFilter}
              exercise={exercisetag}
              difficulty={difficulty}
              main_muscle={main_muscle}
            />
          }
        />
        <div className="row mobile-margin display-flex mt-2">
          <div></div>
          <div className="col-lg-3 col-sm-12">
            <h2>Exercise </h2>
          </div>
          <div className="col-lg-9 col-sm-12 text-end d-flex justify-content-end align-items-center mt-1 mb-4">
            <div className="d-flex justify-content-end">
              <SearchStyle
                className="ms-auto h-0"
                value={filterName}
                onChange={handleFilterByName}
                placeholder="Search"
                label="Search"
                size="small"
                startAdornment={
                  <InputAdornment position="start">
                    <Box
                      component={Icon}
                      icon={searchFill}
                      sx={{ color: "text.disabled" }}
                    />
                  </InputAdornment>
                }
              />
            </div>
            <button
              className="small-contained-button disPlay-not-sm ms-1 me-1 "
              onClick={handleOpenFilterDrawer}
              style={{ position: "relative" }}
            >
              Filters &nbsp;&nbsp;{" "}
              <Icon width={19} height={19} icon={roundFilterList} />
              <span
                style={{
                  position: "absolute",
                  bottom: "20px",
                  right: "9px",
                }}
              >
                {filterCount ? (
                  <div className="dot-filter-count">{filterCount}</div>
                ) : (
                  <div></div>
                )}
              </span>
            </button>
            <Tooltip className="disPlay-on-sm" title={`Filters`}>
              <button
                className="small-contained-button small-button ms-1 me-1 "
                onClick={handleOpenFilterDrawer}
                style={{ position: "relative" }}
              >
                <Icon icon={roundFilterList} />
                <span
                  style={{
                    position: "absolute",
                    bottom: "20px",
                    right: "9px",
                  }}
                >
                  {filterCount ? (
                    <div className="dot-filter-count">{filterCount}</div>
                  ) : (
                    <div></div>
                  )}
                </span>
              </button>
            </Tooltip>

            <button
              className="small-contained-button disPlay-not-sm me-3"
              onClick={() =>
                navigate(`/exercise-add`, {
                  state: id?.slug,
                })
              }
            >
              Add Exercise
            </button>
            <Tooltip className="disPlay-on-sm" title={`Add Exercise`}>
              <button
                className="small-contained-button me-3"
                onClick={() =>
                  navigate(`/exercise-add`, {
                    state: id?.slug,
                  })
                }
              >
                +
              </button>
            </Tooltip>
          </div>
        </div>{" "}
        <div className="row section-space"></div>
        <div className="row mt-4">
          {exercise.length < 1 ? (
            <RecordNotFound title="Exercises" />
          ) : (
            <>
              {" "}
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                m={2}
              >
                <div className="d-flex">
                  <div className="me-2 pointer">
                    <Label
                      onClick={() => {
                        if (filterName !== "") {
                        } else {
                          setSelectedTab(tabs.asc);
                        }
                      }}
                      variant={
                        filterName !== ""
                          ? ""
                          : selectedTab === tabs.asc
                          ? "ghost"
                          : ""
                      }
                      style={{
                        width: 50,
                        cursor: filterName !== "" ? "default" : "pointer",
                      }}
                      color="info"
                    >
                      A-Z
                    </Label>
                  </div>
                  <div className="me-2 pointer">
                    <Label
                      onClick={() => {
                        if (filterName !== "") {
                        } else {
                          setSelectedTab(tabs.close);
                        }
                      }}
                      variant={
                        filterName !== ""
                          ? ""
                          : selectedTab === tabs.close
                          ? "ghost"
                          : ""
                      }
                      style={{
                        width: 50,
                        cursor: filterName !== "" ? "default" : "pointer",
                      }}
                      color="info"
                    >
                      Z-A
                    </Label>
                  </div>
                </div>
              </Stack>
              <InfiniteScroll
                className="w-100 m-auto"
                dataLength={exercise.length}
                next={fetchMoreData}
                hasMore={exercise.length < totalCount ? true : false}
                loader={<h4 className="text-center">Loading...</h4>}
              >
                <div className="row w-100 m-auto">
                  {exercise.map((x, i) => {
                    return (
                      <>
                        <div
                          className="col-lg-3 col-md-3 col-sm-12 mb-4"
                          key={i}
                        >
                          <div className="card mt-1 exercise-cards-shadow cursor h-100">
                            <img
                              src={s3baseUrl + x?.image?.thumbnail_1}
                              className="card-img-top pods-image"
                              alt="workout"
                              onClick={() =>
                                navigate(
                                  `/exercise-details/${x?.exercise_slug}`,
                                  {
                                    state: x,
                                  },
                                )
                              }
                            />
                            <div className="card-body">
                              <div className="row d-flex align-items-end h-100">
                                <div className="col-12 ">
                                  <div
                                    className="h2-heading fw-bold "
                                    onClick={() =>
                                      navigate(
                                        `/exercise-details/${x?.exercise_slug}`,
                                        {
                                          state: x,
                                        },
                                      )
                                    }
                                  >
                                    <span>{htmlDecode(x?.title)}</span>
                                  </div>

                                  {!x?.status && (
                                    <Chip
                                      label={"Inactive"}
                                      variant="contained"
                                      color={"error"}
                                      sx={{
                                        fontSize: "10px",
                                        height: "auto",
                                        width: "auto",
                                      }}
                                    />
                                  )}
                                </div>
                                {x.action_by &&
                                  x.action_by == "coach_user" &&
                                  x.action_id == userInfo?._id && (
                                    <div className="col-12 text-end">
                                      <Chip
                                        label={"Added By You"}
                                        variant="contained"
                                        color={"primary"}
                                        sx={{
                                          fontSize: "10px",
                                          height: "auto",
                                          width: "auto",
                                          borderRadius: "4px",
                                        }}
                                      />
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>
              </InfiniteScroll>
            </>
          )}
        </div>
      </div>
    </>
  );
}
